import React from "react";

const CourseDescription = ({ details }) => {
  if (!details || details.length === 0) {
    return <p>No course description available.</p>;
  }

  return (
    <div className="course-description p-4">
      {details.map((htmlString, index) => (
        <div
          key={index}
          className="mb-3"
          dangerouslySetInnerHTML={{ __html: htmlString }}
        />
      ))}
    </div>
  );
};

export default CourseDescription;
